module.exports = function pad (num, size) {
  var s = '000000000' + num;
  return s.substr(s.length - size);
};



//////////////////
// WEBPACK FOOTER
// ./~/cuid/lib/pad.js
// module id = 200
// module chunks = 0